//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SelectCity",

  data: function () {
    return {
      provisionalCity: null,
      cities: []
    }
  },

  props: {
    cityName: {
      type: String,
      default: function () {
        return this.appCfg?.city?.model?.name || 'Екатеринбург'
      }
    }
  },

  mounted: async function () {
    let {data: allCities} = await this.$api.agent.transport.get("cities?has_cdek_id=1");
    this.cities = allCities.cities;
    await this.checkCityApi();
  },

  methods: {
    clickCity: function () {
      this.$emit('onSelectCity');


      this.$cookies.set("provisional-city", true);
      this.provisionalCity = null;
    },

    checkCityApi: async function () {
      const visibleConfirmCity = Number.parseFloat(process.env.visibleConfirmCity || 0);
      if (!Boolean(visibleConfirmCity)) {
        return
      }

      const acceptCity = this.$cookies.get("accept_city");
      const useProvisionalCity = this.$cookies.get("provisional-city")
      if (!!acceptCity || !!useProvisionalCity) {
        return
      }

      const provisionalCity = await this.$api.agent.transport.get('/cities/current-by-ip').then((res) => {
        return res.data
      }).catch((err) => {
        return null
      })
      if (!provisionalCity) {
        return
      }

      this.provisionalCity = provisionalCity;
    },
    acceptCityApi: async function () {
      this.$cookies.set("provisional-city", true);
      await this.onSetCity(this.provisionalCity.id);
      this.provisionalCity = null;
    },



    async onSetCity(id) {
      let body = {city_id: id};
      try {
        const {data: responseCheckout} = await this.$api.agent.transport.put(
          "cities/current",
          body
        );

        this.$cookies.set('accept_city', id);

        const activeCitySubDomain = (this.cities || []).find((t) => +t.id === +id)?.sub_domain || "";
        const currentFullPath = this.$route?.path || "";


        const locationHost = window.location?.host || "";
        const host = Boolean(locationHost.split(".")?.[0]?.indexOf("linza") <= -1) ?
          locationHost.split(".")?.slice(-(locationHost.split(".").length - 1)).join('.') :
          locationHost;
        const reloadUrl = `${window?.location?.protocol || "https:"}//${Boolean(activeCitySubDomain) ? `${activeCitySubDomain}.` : ""}${host}${currentFullPath}?c=${id}`


        location.href = reloadUrl;
      } catch (error) {
        console.log(error);
      }
    },
  }
}
